module.exports = __webpack_public_path__ + "static/img/thinkyou.2d060d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/thinkyou.png
// module id = 0+st
// module chunks = 10